/**
 * Forecast Settings Tab — tenant-wide toggles for the Purchasing > Forecast
 * schedule grid. Small tab; currently one setting.
 */
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Label } from '../../ui/label';
import { Switch } from '../../ui/switch';
import { LineChart, Loader2 } from 'lucide-react';
import { BarrattFlags } from './types';

interface ForecastSettingsTabProps {
  barrattFlags: BarrattFlags;
  saving: boolean;
  onBarrattFlagsChange: (flags: BarrattFlags) => void;
  onSave: () => void;
}

export function ForecastSettingsTab({
  barrattFlags,
  saving,
  onBarrattFlagsChange,
  onSave,
}: ForecastSettingsTabProps) {
  const update = (updates: Partial<BarrattFlags>) => {
    onBarrattFlagsChange({ ...barrattFlags, ...updates });
  };

  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <LineChart className="h-5 w-5" />
            Forecast Settings
          </CardTitle>
          <CardDescription>
            Controls for the Purchasing &rarr; Forecast schedule grid.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-start justify-between gap-4 p-3 rounded-md border">
            <div>
              <Label className="font-medium">Show Total row</Label>
              <p className="text-sm text-muted-foreground mt-1">
                Render the purple Total row beneath every Open PO + Forecast
                pair. The Total row is the sum of Open PO and Forecast
                quantities per bucket. On by default; turn off to keep the
                grid compact when the combined number isn't needed.
              </p>
            </div>
            <Switch
              checked={barrattFlags.show_forecast_total}
              onCheckedChange={(checked) => update({ show_forecast_total: checked })}
            />
          </div>

          <div className="flex justify-end">
            <Button onClick={onSave} disabled={saving}>
              {saving && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}
              Save
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
